<template>
    <Warning
        :type="type"
        border="left"
        colored-border
        :color="defaultColor"
        :elevation="elevation"
        class="text-body-2 mb-4"
        :icon="icon || 'info'"
    >
        <slot />
        <template slot="button">
            <slot name="button" />
        </template>
    </Warning>
</template>

<script>
import Warning from "./warning.vue";

export default {
    props: {
        elevation: {
            type: Number,
            default: 0,
        },
        icon: {
            type: String,
            required: false,
        },
        color: {
            type: String,
            required: false,
        },
        type: {
            type: String,
            required: false,
            default: "error",
        },
    },
    computed: {
        defaultColor() {
            if (this.color) {
                return this.color;
            }
            return "error";
        },
    },
};
</script>
